
export default {
    name: 'rapport-reglement-reliquat',
    components: {},
    props: {
        rapport_reglement_reliquats: Array,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient",  { key: 'montant', label: 'Montant' }
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            reglement_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshReportReliquat()
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshReportReliquat() {
            if (this.rapport_reglement_reliquats) {
                this.reglement_len = this.rapport_reglement_reliquats.length
            }
        }
    }
}